import state from "./moduleOptimizationGroupState.js";
import mutations from "./moduleOptimizationGroupMutations.js";
import actions from "./moduleOptimizationGroupActions.js";
import getters from "./moduleOptimizationGroupGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
